import {Button, Processing, Show} from '@ultradent/components';
import Icon from '@components/common/Icon';
import {Link, useOutletContext} from 'react-router-dom';
import cleanSku from '@util/cleanSku';

const LBL_NO_RESULTS = upi.i18n.getTextFromKey( 'lbl-noResults', 'No results' );

const ERROR_HEADING = upi.i18n.getTextFromKey( 'lbl-errorsListHeading',
    'Sorry, there was problem getting this list.' );
const LIST_EMPTY_LABEL = upi.i18n.getTextFromKey( 'lbl-ListEmptyHeadingGeneric',
    'Sorry, we were not able to find any items for this region.' );

const ListEmpty = () => (
    <div className="mb-12 subheading-sm leading-normal">
        <h2 className="text-lg font-normal">{LIST_EMPTY_LABEL}</h2>
    </div>
);

const ListError = () => (
    <div className="mb-12 subheading-sm leading-normal">
        <h2 className="text-lg font-normal color-error">{ERROR_HEADING}</h2>
    </div>
);

const Loading = () =>
    <div className="flex w-full justify-center">
        <Processing/>
    </div>;

const NoResults = () =>
    <div className="py-3 border-t border-solid border-grey-lighter">
        <span className="text-title italic ml-10">{LBL_NO_RESULTS}</span>
    </div>;

const List = ( {list = [], isLoading} ) => {

    if ( isLoading ) {
        return <Loading/>;
    }

    if ( !list.length ) {
        return <ListEmpty/>
    }

    return <div>
        {list.map( item => <ListRow {...item}/> )}
    </div>
};

const ListRow = ( {sku, kitName} ) =>
    <div className="py-3 text-body-sm font-semibold border-t border-grey-lighter border-solid">
        <Link to={`./${sku}`}>{cleanSku( sku )} - {kitName}</Link>
    </div>

export const ProductDocumentationList = () => {
    const {productDocumentationApi} = useOutletContext();
    const {results, isLoading, hasError, doShowMoreAction, onShowMore} = productDocumentationApi;

    if ( !isLoading && hasError ) {
        return <ListError/>;
    }

    return (
        <div>
            <List list={results} isLoading={isLoading}/>
            <Show when={doShowMoreAction}>
                <div className="flex justify-center py-8">
                    <Button type={'button'} primary onClick={onShowMore}>
                        Show more
                        <Icon.ui name="arrow-down" className="text-xs ml-2"/>
                    </Button>
                </div>
            </Show>
        </div>

    );
}

ProductDocumentationList.Error = ListError;
ProductDocumentationList.NoResults = NoResults;
ProductDocumentationList.Empty = ListEmpty;

export default ProductDocumentationList;